<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {User} from 'src/typings';

    export let user: User;

    const localize = getLocalization();
</script>

<span class="sr-only">{localize(/* @kp-localization ctenar.username */ 'ctenar.username')}:</span>

<code class="username"
      title={localize(/* @kp-localization ctenar.username */ 'ctenar.username')}>
    {user.username}
</code>